const supportedCountries: server.dto.Countries[] = [
  "germany",
  "belgium"
];

export const countrySupportsPeppol = (country: server.dto.Countries) => {
  return supportedCountries.includes(country);
}